// Shared helpers for Shot Builder hooks.
//
// All shot endpoints return the permissive `ShotBuilderResponse` envelope
// (`StandardResponse & { data?: unknown }`). The generated client wraps that
// body under `result.data`, so the actual payload lives at `result.data.data`.
// `data` is intentionally untyped on the wire — the caller asserts the concrete
// shape from `@/types/shots`, which is the authoritative contract.

interface SdkResult {
  data?: { data?: unknown } | null;
}

/** Unwrap the payload from a Shot Builder SDK response (`result.data.data`). */
export function unwrapData<T>(result: SdkResult | undefined, fallback: T): T {
  const payload = result?.data?.data;
  return (payload ?? fallback) as T;
}
